//
//
//
//
//
//

import { searchServiceContent } from '@/https/user'

export default {
  name: 'RServiceContent',

  data () {
    return { serviceContent: '' }
  },

  created () {
    this.getServiceContent()
  },

  methods: {
    async getServiceContent () {
      const { data } = await searchServiceContent({ wid: this.$route.query.wid })
      this.serviceContent = data || ''
    },
  },
}
